import { render, staticRenderFns } from "./ApplyWay.vue?vue&type=template&id=56646d74&scoped=true&"
import script from "./ApplyWay.vue?vue&type=script&lang=js&"
export * from "./ApplyWay.vue?vue&type=script&lang=js&"
import style0 from "./ApplyWay.vue?vue&type=style&index=0&id=56646d74&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56646d74",
  null
  
)

export default component.exports